import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Intervals } from '../interfaces/intervals.interface';

@Pipe({
  name: 'agodate',
  standalone: true,
  pure: false,
})
export class AgoDatePipe implements PipeTransform {
  intervals: Intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  };

  constructor(private tr: TranslateService) {}

  public transform(value: string) {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) {
        return 'Just now';
      }

      for (const i in this.intervals) {
        if (Object.prototype.hasOwnProperty.call(this.intervals, i)) {
          const counter = Math.floor(
            seconds / this.intervals[i as keyof Intervals]
          );
          if (counter > 0) {
            if (counter === 1) {
              return (
                counter +
                this.tr.instant('main.' + i) +
                ' ' +
                this.tr.instant('main.ago')
              );
            } else {
              return (
                counter +
                this.tr.instant('main.' + i) +
                this.tr.instant('main.s_ago')
              );
            }
          }
        }
      }
    }
    return value;
  }
}
